:host {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
}

::slotted(*) {
  display: block !important;
  line-height: 1;
}

.cart {
  &__button {
    padding: 0 4px;
    height: 100%;
    display: grid;
    align-items: center;
  }

  &__content {
    position: relative;
  }

  &__count {
    box-sizing: border-box;
    position: absolute;
    inset: -12px -16px auto auto;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    border-radius: var(--sc-cart-icon-counter-border-radius, 9999px);
    color: var(--sc-cart-icon-counter-color, var(--sc-color-primary-text, var(--sc-color-white)));
    background: var(--sc-cart-icon-counter-background, var(--sc-color-primary-500));
    box-shadow: var(--sc-cart-icon-box-shadow, var(--sc-shadow-x-large));
    padding: 2px 6px;
    line-height: 14px;
    min-width: 14px;
    z-index: 1;
  }

  &__icon {
    font-size: var(--sc-cart-icon-size, 1.1em);
    cursor: pointer;

    sc-icon {
      display: block;
    }
  }
}
